import { Link } from "react-router-dom";
import Logo from "../ui/Logo";
import { contacts, formatPhone } from "../../data/siteData";

function Footer() {
  return (
    <footer className="border-t border-cyan-300/10 bg-[#02070d]">
      <div className="shell grid gap-8 py-10 md:grid-cols-[1.2fr_1fr_1fr]">
        <div>
          <Link to="/" className="text-left">
            <Logo />
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-6 text-slate-400">
            Elektroinstalace pro domy, byty a firmy v Karlovarském kraji.
          </p>
        </div>
        <div>
          <h3 className="text-sm font-bold uppercase tracking-wide text-white">Kontakt</h3>
          <p className="mt-3 text-sm leading-7 text-slate-400">
              Tel: <a href={`tel:+420`+contacts.tel}><b>+420 {formatPhone(contacts.tel)}</b></a>
              <br />
              Email: <a href={`mailto:`+contacts.email}><b>{contacts.email}</b></a>
              <br />
              IČO: <b>{contacts.ico}</b>
              <br />
              TIČR ev. č: <b>{contacts.ticr}</b>
          </p>
        </div>
          <div>
              <h3 className="text-sm font-bold uppercase tracking-wide text-white">Partner</h3>
              <a href="https://lexikonn.eu" target="_blank" className="mt-3 inline-flex text-sm font-semibold text-cyan-300 hover:text-cyan-200">
                  Lexikonn.eu
              </a>
          </div>
      </div>
    </footer>
  );
}

export default Footer;
